import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { textCss } from '../../../common/Css';
import { getPOById } from '../../../actions/payments';
import { PoApprovalForm } from './PoApprovalForm';
import Loader from '../../../common/Loader';
import IconToolTip from '../../../common/IconToolTip';
import { closeFullScreenModalAction } from '../../../actions/modal';
import NoResultFound from '../../../common/NoResultFound';

export default function PoApproval({ poId }) {

    const dispatch = useDispatch();
    const purchaseOrderDetails = useSelector((state) => state.payments.purchaseOrderDetails);
    const isPoByIdLoading = useSelector((state) => state.loading.isPoByIdLoading);
    const poData = purchaseOrderDetails && purchaseOrderDetails[poId] ? purchaseOrderDetails[poId] : {};


    useEffect(() => {
        dispatch(getPOById({ id: poId }));
    }, [dispatch, poId]);


    return (
        <div className='subContainer title-4 px-5 pt-5'>
            <div className={`titleContainer sticky  w-full z-20`}>
                <div className='md:flex max-w-full items-center'>
                    <div
                        onClick={() => dispatch(closeFullScreenModalAction())}
                        className='hover:text-scogoorange hover:bg-white pr-2 py-1 hover:shadow-md text-scogoprimary cursor-pointer flex items-center text-font20  rounded-md'
                    >
                        <span className='material-icons  m-0 font-bold '>chevron_left</span>
                        <span className='m-0'>BACK</span>
                    </div>
                    <div>
                        <h1 className={textCss?.moduleTitle}>Approve PO : {poData && <span className='text-scogobgsky text-font16'>{poData.po_number}</span>}</h1>
                    </div>

                    {poData && poData?.status === 'APPROVED' ?
                        <div className="ml-5 px-3 py-1.5 bg-scogobgsky text-white rounded-md font-medium text-sm inline-flex items-center">
                            <span className="material-icons text-sm mr-1">check_circle</span>
                            <span>PO Approved</span>
                        </div>
                        :
                        <></>
                    }

                    <div
                        className='ml-auto cursor-pointer'
                        onClick={() => {
                            dispatch(closeFullScreenModalAction());
                        }}
                    >
                        <IconToolTip title='Close'>
                            <span className='material-icons text-scogoprimary font-medium align-middle text-4xl hover:text-scogoorange'>highlight_off</span>
                        </IconToolTip>
                    </div>
                </div>
            </div>
            {isPoByIdLoading ? (
                <div className=''>
                    <Loader color='#F48A21' size='65' speed='1' thickness='3' margin='150px' />
                </div>
            ) : <PoApprovalForm poData={poData} />}
            {!isPoByIdLoading && !poData && <NoResultFound message='PO Not Found' />}
        </div>
    );
}
